import { types } from "../../types/types";
import { MENU_ADICCIONES } from "../../components/adicciones/data/constants";

const initialState = {
  route: "",
  activeStep: 0,
  activeBreadcrumb: MENU_ADICCIONES.DESELECCIONAR,
  afiliadoSeleccionado: null,
  certificados: [],
  documentacion: [],
  documentacionAfiliado: [],
  efectorSeleccionado: null,
  estadoSolicitudes: null, //ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA,
  formularioCud: null,
  solicitudes: [],
  solicitudesContadores: [],
  solicitudSeleccionada: null,
  solicitudesTomadas: [],
  solicitudesTomadasUsuario: [],
  subTiposSolicitudes: [],
  tiposDocumentacion: [],
  tiposDocumentacionAbm: [],
  tiposPrestaciones: [],
  tiposSolicitudes: [],
  tiposTransportes: [],
  trackingSolicitud: [],
  loading: false,
  notas: [],
  consumosAfiliado: [],
  practicas: []
};

export const adiccionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.start:
      return {
        ...state,
        loading: true,
      };
    case types.adiccionesSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.adiccionesSetBreadcrumbCud:
      return {
        ...state,
        activeBreadcrumb: action.payload
      };
    case types.certificadosClean:
      return {
        ...state,
        comprobantes: [],
        loading: false,
      };
    case types.certificadosSuccess:
      return {
        ...state,
        comprobantes: action.payload,
        loading: false,
      };
    case types.certificadosError:
      return {
        ...state,
        loading: false,
      };
    case types.certificadosPost:
      return {
        ...state,
        certificados: [
          action.payload,
          ...state.certificados
        ],
        loading: false,
      };
    case types.certificadosUpdated:
      return {
        ...state,
        certificados: state.certificados.map(
          (item) => item.idCertificado === action.payload.idCertificado
            ? {...item, ...action.payload}
            : item
        ),
        loading: false,
      };
    case types.certificadosDelete: 
      return {
        ...state,
        certificados: state.certificados.filter(item => item.idCertificado !== action.payload),
        loading: false,
      };
    //CLEAR
    case types.adiccionesClearReducer:
      return {
        ...initialState,
        activeStep: state.activeStep,
        activeBreadcrumb: state.activeBreadcrumb,
      };
    //TIPO DOCUMENTACION ABM
    case types.adiccionesGetTiposDocumentacionSuccess:
      return {
        ...state,
        tiposDocumentacion: action.payload,
      };
    case types.adiccionesGetTiposDocumentacionError:
      return {
        ...state,
        tiposDocumentacion: [],
      };
    case types.adiccionesPostTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: [
          ...state.tiposDocumentacion,
          action.payload
        ],
      };
    case types.adiccionesPutTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.map(item => (
          item.idTipoDoc === action.payload.idTipoDoc ? action.payload : item
        )),
      };
    case types.adiccionesDeleteTiposDocumentacion:
      return {
        ...state,
        tiposDocumentacion: state.tiposDocumentacion.filter(item => (
          item.idTipoDoc !== action.payload.idTipoDoc
        )),
      };
    //TIPO DOCUMENTACION SOLICITUD
    case types.adiccionesGetTiposDocumentacionSuccessAbm:
      return {
        ...state,
        tiposDocumentacionAbm: action.payload,
      };
    case types.adiccionesGetTiposDocumentacionErrorAbm:
      return {
        ...state,
        tiposDocumentacionAbm: [],
      };
    case types.adiccionesCleanTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: [],
      };
    case types.adiccionesPostTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: [
          ...state.tiposDocumentacionAbm,
          action.payload
        ],
      };
    case types.adiccionesPutTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: state.tiposDocumentacionAbm.map(item => (
          (!!action.payload.idTipoDocSolicitud && item.idTipoDocSolicitud === action.payload.idTipoDocSolicitud) || 
          (!!action.payload.idTipoDocAfiliado && item.idTipoDocAfiliado === action.payload.idTipoDocAfiliado)
          ? action.payload : item
        )),
      };
    case types.adiccionesDeleteTiposDocumentacionAbm:
      return {
        ...state,
        tiposDocumentacionAbm: state.tiposDocumentacionAbm.filter(item => (
          (!!item.idTipoDocSolicitud && item.idTipoDocSolicitud !== action.payload) || 
          (!!item.idTipoDocAfiliado && item.idTipoDocAfiliado !== action.payload)
        )),
      };
    //DOCUMENTACION SOLICITUD
    case types.adiccionesGetDocumentacionSuccess:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.adiccionesGetDocumentacionError:
      return {
        ...state,
        documentacion: [],
      };
    //DOCUMENTACION AFILIADO
    case types.discapacidadGetDocumentacionAfiliadoSuccess:
      return {
        ...state,
        documentacionAfiliado: action.payload,
      };
    case types.discapacidadGetDocumentacionAfiliadoError:
      return {
        ...state,
        documentacionAfiliado: [],
      };
    //SOLICITUDES TOMADAS
    case types.adiccionesSolicitudesTomadasUsuarioSuccess:
      return {
        ...state,
        solicitudesTomadasUsuario: action.payload,
      };
    case types.adiccionesSolicitudesTomadasUsuarioLiberar:
      return {
        ...state,
        solicitudesTomadasUsuario: state.solicitudesTomadasUsuario.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.adiccionesSolicitudesDesmarcarLiberada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) =>
          item.idSolicitud === action.payload.idSolicitud
            ? {
              ...item,
              solicitudesTomadas: [],
            }
            : item
        ),
      };
    case types.adiccionesSolicitudesTomadasUsuarioAgregar:
      return {
        ...state,
        solicitudesTomadasUsuario: [
          ...state.solicitudesTomadasUsuario,
          action.payload,
        ],
      };
    case types.adiccionesSolicitudesTomadasUsuarioError:
      return {
        ...state,
        solicitudesTomadasUsuario: [],
      };
    case types.adiccionesSolicitudesTomadasSuccess:
      return {
        ...state,
        solicitudesTomadas: action.payload,
      };
    case types.adiccionesSolicitudesTomadasLiberar:
      return {
        ...state,
        solicitudesTomadas: state.solicitudesTomadas.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.adiccionesSolicitudesTomadasError:
      return {
        ...state,
        solicitudesTomadas: [],
      };
    case types.adiccionesSolicitudesTomadasLimpiar:
      return {
        ...state,
        solicitudesTomadas: [],
        solicitudesTomadasUsuario: [],
      };
    case types.adiccionesSolicitudesMarcarTomada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) =>
          item.idSolicitud === action.payload.solicitud.idSolicitud
            ? {
                ...item,
                solicitudesTomadas: [
                  {
                    id: action.payload.id,
                    usuarioTomada: { userName: action.payload.auth.userName },
                    idUsuarioTomada: action.payload.auth.idUsuario,
                  },
                ],
              }
            : item
        ),
      };
    //TRACKING SOLICITUD
    case types.adiccionesGetTrackingSolicitudSuccess:
      return {
        ...state,
        trackingSolicitud: action.payload,
      };
    case types.adiccionesGetTrackingSolicitudError:
      return {
        ...state,
        trackingSolicitud: [],
      };
    //ESTADO SOLICITUDES
    case types.adiccionesSetEstadoSolicitudes:
      return {
        ...state,
        estadoSolicitudes: action.payload,
      };
    //AFILIADO SELECCIONADO
    case types.adiccionesSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.adiccionesCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      };
    //EFECTOR SELECCIONADO
    case types.adiccionesSetEfectorSeleccionado:
      return {
        ...state,
        efectorSeleccionado: action.payload,
      };
    case types.adiccionesCleanEfectorSeleccionado:
      return {
        ...state,
        efectorSeleccionado: null,
      };
    //TIPOS PRESTACIONES
    case types.discapacidadGetTiposPrestacionesSuccess:
      return {
        ...state,
        tiposPrestaciones: action.payload,
      };
    case types.discapacidadGetTiposPrestacionesError:
      return {
        ...state,
        tiposPrestaciones: [],
      };
    //TIPOS SOLICITUDES
    case types.adiccionesGetTiposSolicitudesSuccess:
      return {
        ...state,
        tiposSolicitudes: action.payload,
      };
    case types.adiccionesGetTiposSolicitudesError:
      return {
        ...state,
        tiposSolicitudes: [],
      };
    //TIPOS TRANSPORTE
    case types.discapacidadGetTiposTransportesSuccess:
      return {
        ...state,
        tiposTransportes: action.payload,
      };
    case types.discapacidadGetTiposTransportesError:
      return {
        ...state,
        tiposTransportes: [],
      };
    //SUB-TIPOS SOLICITUDES
    case types.discapacidadGetSubTiposSolicitudesSuccess:
      return {
        ...state,
        subTiposSolicitudes: action.payload,
      };
    case types.discapacidadGetSubTiposSolicitudesError:
      return {
        ...state,
        subTiposSolicitudes: [],
      };
    //SOLICITUDES
    case types.adiccionesGetSolicitudesSuccess:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case types.adiccionesCleanSolicitudes:
      return {
        ...state,
        solicitudes: [],
      };
    case types.adiccionesGetSolicitudesError:
      return {
        ...state,
        solicitudes: [],
      };
    case types.adiccionesGetContadoresSolicitudesSuccess:
      return {
        ...state,
        solicitudesContadores: action.payload,
      };
    case types.adiccionesGetContadoresSolicitudesError:
      return {
        ...state,
        solicitudesContadores: [],
      };  
    //SOLICITUD SELECCIONADA
    case types.adiccionesCleanSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: null,
      };
    case types.adiccionesSetSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.adiccionesUpdateSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.discapacidadUpdateTerapiaSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          integracionTerapia: action.payload
        },
      };
    case types.discapacidadUpdateTransporteSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          integracionTransporte: action.payload
        },
      };
    case types.adiccionesAddPractica:      
      const practicasAux = Array.isArray(state.solicitudSeleccionada.practicas)
        ? [...state.solicitudSeleccionada.practicas]
        : [];
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          practicas: [...practicasAux, action.payload],
        },
      };
    case types.adiccionesSetPracticas:
      return {
        ...state,
        solicitudSeleccionada: {
          ...state.solicitudSeleccionada, 
          practicas: action.payload,
        },
      };
    case types.adiccionesGetPracticasSuccess:
      return {
        ...state,
        practicas: action.payload,
      };
    //FORMULARIO CUD
    case types.discapacidadSetFormularioCudSuccess:
      return {
        ...state,
        formularioCud: action.payload,
      };
    //NOTAS 
    case types.adiccionesGetNotasSuccess:
      return {
        ...state,
        notas: action.payload,
      };
      case types.adiccionesGetNotasError:
        return {
          ...state,
          notas: null,
        };
        case types.adiccionesGetConsumosAfiliadosSuccess:
          return {
            ...state,
           consumosAfiliado: action.payload,
          };
    default:
      return state;
  }
};
  